module.exports = __webpack_public_path__ + "static/media/search.cb9b98b3.svg";